// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputContainer_O7ayK {
  background-color: var(--f5-background) ;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
}

.labelContainer_UOn1T {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: var(--white-background);
  border-radius: 15px;
  padding: 0 5px;
}

.labelText_zL_C7 {
  font-size: 12px;
}

.closeButton_KajIJ {
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.inputWrapper_NEr8g {
  display: flex;
  gap: 5px;
  width: 100%;
  align-items: center;
}

.iconContainer_cTyFr {
  display: flex;
  align-items: center;
}

.inputField_xqThQ {
  background-color: transparent;
  border: none;
  width: 100%;
  height: 32px;
  color: var(--_1e0045-color);
  font-weight: 300;
  padding: 8px;
  box-sizing: border-box;
  font-size: 13px;
  outline: none;
  &::placeholder {
    color: var(--_71717a-color);
  }
}

.actionText_F4dwT {
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  font-weight: 700;
}

.graySelectLocationBtn_tY9Dl{
  background-color: #4F5660;
  color: var(--white-background);
  border-radius: 12px;
  font-weight: 400;
  padding: 6px 12px;
}

.remitenteOption_a5KtJ {
  font-size: 12px;
  white-space: nowrap;
  background-color: var(--white-background);
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid var(--e8-border);
  color: var(--_5c6c74-color);
  border-radius: 30px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.remitentesInputContainer_c5qzg {
  background-color: var(--f5-background) ;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  border-radius: 4px;
  padding: 0px 18px;
  font-family: "Inter", sans-serif;
  overflow: hidden;
}

.remitentesInputWrapper_sxaAI {
  display: flex;
  gap: 5px;
  width: 100%;
  align-items: center;
  overflow-x: auto;
  max-width: 400px;
  scrollbar-width: none; 
  -ms-overflow-style: none; 
  scroll-behavior: smooth;
}

.remitentesInputWrapper_sxaAI::-webkit-scrollbar {
  display: none; 
}




`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/InputComponent/InputComponent.module.css"],"names":[],"mappings":"AACA;EACE,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n.inputContainer {\n  background-color: var(--f5-background) ;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 32px;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n}\n\n.labelContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background-color: var(--white-background);\n  border-radius: 15px;\n  padding: 0 5px;\n}\n\n.labelText {\n  font-size: 12px;\n}\n\n.closeButton {\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.inputWrapper {\n  display: flex;\n  gap: 5px;\n  width: 100%;\n  align-items: center;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n}\n\n.inputField {\n  background-color: transparent;\n  border: none;\n  width: 100%;\n  height: 32px;\n  color: var(--_1e0045-color);\n  font-weight: 300;\n  padding: 8px;\n  box-sizing: border-box;\n  font-size: 13px;\n  outline: none;\n  &::placeholder {\n    color: var(--_71717a-color);\n  }\n}\n\n.actionText {\n  cursor: pointer;\n  font-size: 12px;\n  white-space: nowrap;\n  font-weight: 700;\n}\n\n.graySelectLocationBtn{\n  background-color: #4F5660;\n  color: var(--white-background);\n  border-radius: 12px;\n  font-weight: 400;\n  padding: 6px 12px;\n}\n\n.remitenteOption {\n  font-size: 12px;\n  white-space: nowrap;\n  background-color: var(--white-background);\n  padding: 5px 10px;\n  border-radius: 4px;\n  border: 1px solid var(--e8-border);\n  color: var(--_5c6c74-color);\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.remitentesInputContainer {\n  background-color: var(--f5-background) ;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 32px;\n  border-radius: 4px;\n  padding: 0px 18px;\n  font-family: \"Inter\", sans-serif;\n  overflow: hidden;\n}\n\n.remitentesInputWrapper {\n  display: flex;\n  gap: 5px;\n  width: 100%;\n  align-items: center;\n  overflow-x: auto;\n  max-width: 400px;\n  scrollbar-width: none; \n  -ms-overflow-style: none; \n  scroll-behavior: smooth;\n}\n\n.remitentesInputWrapper::-webkit-scrollbar {\n  display: none; \n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `inputContainer_O7ayK`,
	"labelContainer": `labelContainer_UOn1T`,
	"labelText": `labelText_zL_C7`,
	"closeButton": `closeButton_KajIJ`,
	"inputWrapper": `inputWrapper_NEr8g`,
	"iconContainer": `iconContainer_cTyFr`,
	"inputField": `inputField_xqThQ`,
	"actionText": `actionText_F4dwT`,
	"graySelectLocationBtn": `graySelectLocationBtn_tY9Dl`,
	"remitenteOption": `remitenteOption_a5KtJ`,
	"remitentesInputContainer": `remitentesInputContainer_c5qzg`,
	"remitentesInputWrapper": `remitentesInputWrapper_sxaAI`
};
export default ___CSS_LOADER_EXPORT___;
